import { render } from "./main-slider.vue?vue&type=template&id=fc368f4c"
import script from "./main-slider.vue?vue&type=script&lang=js"
export * from "./main-slider.vue?vue&type=script&lang=js"

import "./main-slider.vue?vue&type=style&index=0&id=fc368f4c&lang=css"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__